/* Mikes Toolshop – Produktseite V2 (29.10.2026) */
(function () {
  if (window.mtsProdukt) return;
  window.mtsProdukt = true;

  var KEY = 'mts-preismodus';
  var root = document.documentElement;

  /* ---------- Privat / Betrieb ---------- */
  function getMode() {
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) {}
    if (stored === 'firma' || stored === 'privat') return stored;
    var el = document.querySelector('[data-mts-modus-default]');
    return el ? el.getAttribute('data-mts-modus-default') : 'privat';
  }
  function setMode(mode, save) {
    root.classList.toggle('mts-firma', mode === 'firma');
    document.querySelectorAll('[data-mts-modus]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-mts-modus') === mode ? 'true' : 'false');
    });
    if (save) { try { localStorage.setItem(KEY, mode); } catch (e) {} }
  }

  /* ---------- Varianten ---------- */
  function showVariant(id) {
    if (!id) return;
    id = String(id);
    document.querySelectorAll('[data-mts-variants]').forEach(function (box) {
      var items = box.querySelectorAll(':scope > [data-mts-v]');
      var hit = false;
      items.forEach(function (el) { if (el.getAttribute('data-mts-v') === id) hit = true; });
      if (!hit) return;
      items.forEach(function (el) { el.hidden = el.getAttribute('data-mts-v') !== id; });
    });
    document.querySelectorAll('.mts-vk__card').forEach(function (c) {
      var on = c.getAttribute('data-variant') === id;
      c.setAttribute('aria-checked', on ? 'true' : 'false');
      c.tabIndex = on ? 0 : -1;
    });
  }

  function pickVariant(card) {
    var value = card.getAttribute('data-option');
    var inputs = document.querySelectorAll('variant-picker input.js-option');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === value) { inputs[i].click(); showVariant(card.getAttribute('data-variant')); return; }
    }
    var sel = document.querySelector('variant-picker select.js-option, variant-picker select');
    if (sel) {
      for (var j = 0; j < sel.options.length; j++) {
        if (sel.options[j].value === value) {
          sel.value = value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          showVariant(card.getAttribute('data-variant'));
          return;
        }
      }
    }
  }

  /* ---------- Lieferdatum ---------- */
  function viennaNow() {
    var v = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', weekday: 'short', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { if (p.type !== 'literal') v[p.type] = p.value; });
    return {
      y: +v.year, m: +v.month, d: +v.day, h: +v.hour, min: +v.minute,
      wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(v.weekday)
    };
  }
  function addWorkdays(date, n) {
    var r = new Date(date.getTime()), c = 0;
    while (c < n) { r.setUTCDate(r.getUTCDate() + 1); if (r.getUTCDay() !== 0 && r.getUTCDay() !== 6) c++; }
    return r;
  }
  function startDate(cutoff) {
    var now = viennaNow();
    var today = new Date(Date.UTC(now.y, now.m - 1, now.d));
    var parts = (cutoff || '13:30').split(':');
    var cm = (+parts[0] || 13) * 60 + (+parts[1] || 0);
    var before = now.h * 60 + now.min < cm;
    return now.wd !== 0 && now.wd !== 6 && before ? today : addWorkdays(today, 1);
  }
  function monthLong(d) { return new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', month: 'long' }).format(d); }
  function range(a, b) {
    if (a.getTime() === b.getTime()) return a.getUTCDate() + '. ' + monthLong(a);
    if (a.getUTCMonth() === b.getUTCMonth()) return a.getUTCDate() + '.–' + b.getUTCDate() + '. ' + monthLong(b);
    return a.getUTCDate() + '. ' + monthLong(a) + ' – ' + b.getUTCDate() + '. ' + monthLong(b);
  }
  function parseDays(txt) {
    var m = String(txt || '').trim().match(/^(\d+)\s*(?:[-–—]\s*(\d+))?\s*(?:Werktage?|Tage?)?$/i);
    if (!m) return null;
    var a = +m[1], b = m[2] ? +m[2] : a;
    if (a < 1 || b < a || b > 3650) return null;
    return [a, b];
  }
  function initDates() {
    document.querySelectorAll('[data-mts-days]').forEach(function (el) {
      var days = parseDays(el.getAttribute('data-mts-days'));
      if (!days) return;
      var s = startDate(el.getAttribute('data-mts-cutoff'));
      el.innerHTML = '';
      el.appendChild(document.createTextNode('Bei dir voraussichtlich: '));
      var b = document.createElement('strong');
      b.textContent = range(addWorkdays(s, days[0]), addWorkdays(s, days[1]));
      el.appendChild(b);
    });
  }

  /* ---------- Aktion: Restlaufzeit ---------- */
  function initAktion() {
    document.querySelectorAll('[data-mts-ende]').forEach(function (el) {
      var end = Number(el.getAttribute('data-mts-ende')) * 1000;
      if (!end) return;
      var left = end - Date.now();
      if (left <= 0) { var box = el.closest('.mts'); if (box) box.hidden = true; return; }
      var days = Math.floor(left / 86400000);
      var t = days === 0 ? 'endet heute' : days === 1 ? 'noch 1 Tag' : 'noch ' + days + ' Tage';
      el.textContent = ' · ' + t;
    });
  }

  /* ---------- Erreichbarkeit ---------- */
  function initStatus() {
    document.querySelectorAll('[data-mts-zeiten]').forEach(function (el) {
      var now = viennaNow();
      var wd = now.wd === 0 ? 7 : now.wd;
      var mins = now.h * 60 + now.min;
      var rules = [];
      el.getAttribute('data-mts-zeiten').split(';').forEach(function (r) {
        var m = r.trim().match(/^(\d)(?:-(\d))?\s+(\d{1,2}):(\d{2})-(\d{1,2}):(\d{2})$/);
        if (m) rules.push({ from: +m[1], to: +(m[2] || m[1]), o: +m[3] * 60 + +m[4], c: +m[5] * 60 + +m[6] });
      });
      if (!rules.length) return;
      var today = rules.filter(function (r) { return wd >= r.from && wd <= r.to; })[0];
      var hhmm = function (x) { return Math.floor(x / 60) + (x % 60 ? ':' + ('0' + x % 60).slice(-2) : '') + ' Uhr'; };
      if (today && mins >= today.o && mins < today.c) {
        el.setAttribute('data-open', 'true');
        el.textContent = 'Jetzt erreichbar, heute bis ' + hhmm(today.c);
        return;
      }
      el.setAttribute('data-open', 'false');
      var names = ['', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
      for (var i = 0; i < 8; i++) {
        var d = ((wd - 1 + i) % 7) + 1;
        var r = rules.filter(function (x) { return d >= x.from && d <= x.to; })[0];
        if (!r) continue;
        if (i === 0 && mins >= r.o) continue;
        var when = i === 0 ? 'heute' : i === 1 ? 'morgen' : 'am ' + names[d];
        el.textContent = 'Wieder erreichbar ' + when + ' ab ' + hhmm(r.o) + '. Schreib uns gern per WhatsApp, wir antworten dann.';
        return;
      }
    });
  }

  /* ---------- Start ---------- */
  function init() {
    // Privat/Betrieb-Umschalter entfernt: immer Bruttoanzeige, alte Auswahl löschen
    root.classList.remove('mts-firma');
    try { localStorage.removeItem(KEY); } catch (e) {}

    if (document.querySelector('.mts-vk')) {
      document.querySelectorAll('variant-picker').forEach(function (p) {
        var block = p.closest('.product-info__block') || p;
        block.style.display = 'none';
      });
    }

    var urlV = new URLSearchParams(location.search).get('variant');
    if (urlV) showVariant(urlV);

    initDates();
    initAktion();
    initStatus();

    // Produktdaten nur einmal anzeigen, falls zusätzlich ein eigener Abschnitt angelegt wurde
    document.querySelectorAll('.mts-info--unten').forEach(function (el, i) { if (i > 0) el.remove(); });
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.mts-vk__card');
    if (card && card.getAttribute('aria-disabled') !== 'true') pickVariant(card);
  });

  document.addEventListener('keydown', function (e) {
    var card = e.target.closest && e.target.closest('.mts-vk__card');
    if (!card || ['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].indexOf(e.key) < 0) return;
    e.preventDefault();
    var cards = Array.prototype.slice.call(card.parentNode.querySelectorAll('.mts-vk__card'));
    var dir = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1;
    var next = cards[(cards.indexOf(card) + dir + cards.length) % cards.length];
    next.focus();
    next.click();
  });

  document.addEventListener('on:variant:change', function (e) {
    if (e.detail && e.detail.variant) showVariant(e.detail.variant.id);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
